import React from 'react';
import PropTypes from 'prop-types';
import Revenue from '../../common/Revenue';
import styles from './Availability.module.scss';

function Availability(props) {
  const { inventory } = props;

  const onePercent = props.maxOfAllInventory / 100;
  const percents = inventory / onePercent;

  if (inventory === 0) {
    return <div className={styles.out_of_stock}>Out of stock</div>;
  }

  const style = {
    width: `${percents}%`,
  };

  return (
    <div className={styles.input} style={style}>
      <Revenue onChange={props.handle} min={0} max={inventory} value={props.quantity} index={props.variantId} />
      <div className={styles.inventory}>{inventory}</div>
    </div>
  );
}

export default Availability;

Availability.propTypes = {
  quantity: PropTypes.number.isRequired,
  handle: PropTypes.func.isRequired,
  variantId: PropTypes.number.isRequired,
  inventory: PropTypes.number.isRequired,
  maxOfAllInventory: PropTypes.number.isRequired,
};
